// Trap focus
function trapFocus(event, element) {
    const focusable = element.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select')
    const firstFocusableElement = focusable[0]
    const lastFocusableElement = focusable[focusable.length - 1]
    const isTabPressed = event.key === 'Tab' || event.keyCode === 9

    if (!isTabPressed) {
        return
    }

    if (event.shiftKey) { // Shift + Tab
        if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus()
            event.preventDefault()
        }
    } else { // Tab
        if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus()
            event.preventDefault()
        }
    }
}